module.exports = __webpack_public_path__ + "img/Union-des-Comores.28acf065.gif";